module.exports = __webpack_public_path__ + "static/media/blog-detail3.04a0d130.svg";